<template>
  <el-drawer
    :visible.sync="drawerShow"
    :destroy-on-close="true"
    v-bind="allProps"
    append-to-body
  >
    <component :is="componentImstances" ref="sub" v-on="allMethods" />
  </el-drawer>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      drawerShow: false,
    };
  },

  props: {
    path: {
      type: String,
      default: "",
    },
  },

  computed: {
    allProps() {
      return this.$attrs;
    },
    allMethods() {
      var methods = {
        show: this.show,
        hide: this.hide,
      };
      return Object.assign(methods, this.$listeners);
    },
    componentImstances() {
      return (resolve) => require([`@/views/${this.path}`], resolve);
    },
  },

  methods: {
    yes() {
      if (this.$refs.sub.yes && typeof this.$refs.sub.yes == "function") {
        this.$refs.sub.yes((x) => {
          this.hide();
        });
      }
    },
    show() {
      this.drawerShow = true;
      setTimeout(() => {
        if (this.$refs.sub.init && typeof this.$refs.sub.init == "function") {
          this.$refs.sub.init(...arguments);
        }
      }, 0);
    },

    hide() {
      this.drawerShow = false;
    },
  },
};
</script>


<style lang="scss">
</style>